import { createSelector } from '@reduxjs/toolkit';
import { AUTHORIZED_MODULE } from '../../configs/moduleNames';
import {
  AUTHORIZED_ESIA_LOGIN,
  AUTHORIZED_LOGIN, AUTHORIZED_LOGOUT,
  CALL_CALLBACK_ESIA,
  FORGOT_PASSWORD,
  GET_ESIA_URL,
  GET_PROFILE_COMPANIES,
  SET_COMPANY,
} from './actions';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';
import {
  LOCAL_STORAGE_APPLICANT_KEY,
  LOCAL_STORAGE_AUTHORIZED_KEY,
  LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT,
  LOCAL_STORAGE_COMPANY_KEY,
} from '../../configs/names';
import { clearStorageAuthorized, setStorageAuthorized } from './reducer';
import { createLoadParameterReducer, createOperationStateReducer } from '../../utils/getCrudConfig';

export const esiaState = {
  esiaState: '',
  esiaRedirectUrl: '',
  loadingEsiaRedirectUrl: false,
  loadingSetCompany: false,
  loadingProfileCompanies: false,
  profileCompaniesList: [],
};

export const esiaReducer = {
  [AUTHORIZED_MODULE + GET_ESIA_URL]: state => ({
    ...state,
    esiaState: '',
    esiaRedirectUrl: '',
    loadingEsiaRedirectUrl: true,
  }),
  [AUTHORIZED_MODULE + GET_ESIA_URL + SUCCESSFUL]: (state, action) => ({
    ...state,
    esiaState: action.payload.state,
    esiaRedirectUrl: action.payload.url,
    loadingEsiaRedirectUrl: true,
  }),
  [AUTHORIZED_MODULE + GET_ESIA_URL + FAILED]: state => ({
    ...state,
    esiaState: '',
    esiaRedirectUrl: '',
    loadingEsiaRedirectUrl: false,
  }),

  [AUTHORIZED_MODULE + CALL_CALLBACK_ESIA]: state => {
    clearStorageAuthorized();
    return {
      ...state,
      token: null,
      authorizedData: {},
      loggedIn: false,
      loginProcess: true,
    };
  },
  [AUTHORIZED_MODULE + CALL_CALLBACK_ESIA + SUCCESSFUL]: (state, action) => {
    const { token, user } = action.payload;
    setStorageAuthorized(token);
    window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT, new Date().getTime());
    window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_KEY, JSON.stringify(user));
    return {
      ...state,
      token,
      loginProcess: false,
      authorizedData: user,
    };
  },
  [AUTHORIZED_MODULE + CALL_CALLBACK_ESIA + FAILED]: state => {
    clearStorageAuthorized();
    return {
      ...state,
      authorizedData: {},
      token: null,
      loggedIn: false,
      loginProcess: false,
      loadingAuthorizedCheck: false,
    };
  },

  ...createLoadParameterReducer(AUTHORIZED_MODULE + GET_PROFILE_COMPANIES, 'profileCompaniesList', 'loadingProfileCompanies'),

  [AUTHORIZED_MODULE + SET_COMPANY]: state => ({
    ...state,
    loadingSetCompany: true,
  }),
  [AUTHORIZED_MODULE + SET_COMPANY + SUCCESSFUL]: (state, action) => {
    window.localStorage.setItem(LOCAL_STORAGE_COMPANY_KEY, JSON.stringify(action.payload));
    window.localStorage.setItem(LOCAL_STORAGE_APPLICANT_KEY, state.profileCompaniesList[0]?.applicant_id);
    return {
      ...state,
      loggedIn: !!state.token && !!action.payload,
      currentCompany: action.payload,
    };
  },
  [AUTHORIZED_MODULE + SET_COMPANY + FAILED]: state => ({
    ...state,
    currentCompany: null,
    loadingSetCompany: false,
  }),
  [AUTHORIZED_MODULE + AUTHORIZED_LOGOUT + SUCCESSFUL]: state => {
    clearStorageAuthorized();
    return {
      ...state,
      authorizedData: {},
      token: null,
      loggedIn: false,
      currentCompany: null,
    };
  },
};
